var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiListController',{attrs:{"fetch":_vm.fetch,"name":"Matches"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return [_c('MatchBookmarkController',{attrs:{"items":items}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }